import { Helmet } from 'react-helmet';
import './acas-main.css';
import ScrollToTop from '../../../../../components/scrollToTop/scrollToTop';
import { useState } from 'react';
import AcasInfo from './acas-info';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Modal, Spinner } from "react-bootstrap";


function Acas() {
  const [showView, setShowView] = useState("principalView");
  const [awbInfo, setAwbInfo] = useState({})
  const [existAcas, setExistAcas] = useState({});
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();

  const handleValidateMaster = async (data) => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/acas`;
      const body = { awb: data.inputMaster }

      const response = await axios.post(url, body);

      setAwbInfo(response.data.body.awbData);
      setExistAcas(response.data.body.existAcas);

      if (response.data.status === 200) {
        setLoading(false);
        setShowView("secondaryView");
      }

    } catch (error) {
      setLoading(false);
      console.error(error.response.data.body);
      Swal.fire("Error", error.response.data.body, "error");
    }
  }

  const updateAcasInfo = async (idMaster) => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/acas/verifyAcas?idMaster=${idMaster}`;
      const response = await axios.get(url);
      setLoading(false);
      setExistAcas(response.data.body);
    } catch (error) {
      setLoading(false);
      console.error(error.response.data.body);
      Swal.fire("Error", "Error, por favor intenta mas tarde", "error");
    }
  }

  const handleMasterChange = (e) => {
    console.log("entra");
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 3) {
      value = value.slice(0, 3) + "-" + value.slice(3, 11);
    }
    setValue('inputMaster', value);
  }

  return (
    <>
      <Helmet>
        <title>Horus | Aceptación</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid">
        {showView === "principalView" && (
          <div className="row justify-content-center">
            <form className="col-6" onSubmit={handleSubmit(handleValidateMaster)}>
              <label htmlFor="inputMaster" className="amc-label">
                Master
              </label>
              <input
                type="text"
                className="form-control"
                id="inputMaster"
                {...register("inputMaster", {
                  required: "Este campo es requerido",
                  pattern: {
                    value: /^\d{3}-\d{8}$/,
                    message: "Formato invalido"
                  }
                })}
                onChange={handleMasterChange}
              />
              {errors.inputMaster && <small className="text-danger">{errors.inputMaster.message}</small>}
              <div className="btns mt-3 d-flex justify-content-end gap-3">
                <button className="btnn" type='submit'>
                  Buscar
                </button>
              </div>
            </form>
          </div>
        )}

        {showView === 'secondaryView' && (
          <AcasInfo awbInfo={awbInfo} existAcas={existAcas} updateAcasInfo={updateAcasInfo} />
        )}
      </div>

      <Modal
        show={loading}
        onHide={() => setLoading(false)}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  )
}

export default Acas;